function revealPage() {
	document.body.classList.add("page-ready");
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", () => {
		requestAnimationFrame(revealPage);
	});
} else {
	requestAnimationFrame(revealPage);
}
